/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Maria Petrunina <maria.petrunina@opensoftdev.com>
 */

define(['backbone'], function(backbone) {
    return backbone.Model.extend(
        {
            defaults: {
                name: null,
                config: null
            },

            /**
             * @param {string|null} keyName
             */
            getConfigValue: function(keyName) {
                var value = this.get('config')[keyName];
                if (value) {
                    return value;
                }

                return null;
            },

            /**
             * @param {Object} dto
             * @returns {DesignerModel}
             */
            fromDTO: function(dto) {
                this.set('name', dto.name);
                this.set('config', dto.config);

                return this;
            }
        },
        {
            NAME_DVS: 'DVS',
            NAME_TWEAK: 'Tweak'
        }
    );
});
